import React from 'react';
import FilterContainer from '@components/filter-panel';
import { DASHBOARD_TYPE } from '@utils/constants';

const FilterContainerWrapper = ({ activeFilter, appliedFilter }) => (
  <FilterContainer
    dashboardId="ml"
    dashboardType={DASHBOARD_TYPE.ML}
    activeMLFilter={activeFilter}
    selectedFilterNames={[appliedFilter.filter.name]}
  />
);

export default React.memo(FilterContainerWrapper);
